var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "money-cash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20 2H4C2.8954 2 2 2.8954 2 4V12C2 13.1046 2.8954 14 4 14H20C21.1046 14 22 13.1046 22 12V4C22 2.8954 21.1046 2 20 2ZM7 8.75H5C4.5859 8.75 4.25 8.4141 4.25 8C4.25 7.5859 4.5859 7.25 5 7.25H7C7.4141 7.25 7.75 7.5859 7.75 8C7.75 8.4141 7.4141 8.75 7 8.75ZM12 10C10.8954 10 10 9.1046 10 8C10 6.8954 10.8954 6 12 6C13.1046 6 14 6.8954 14 8C14 9.1046 13.1046 10 12 10ZM19 8.75H17C16.5859 8.75 16.25 8.4141 16.25 8C16.25 7.5859 16.5859 7.25 17 7.25H19C19.4141 7.25 19.75 7.5859 19.75 8C19.75 8.4141 19.4141 8.75 19 8.75ZM20 15.5C20.7444 15.5 21.4321 15.2624 22 14.8646V16C22 17.1046 21.1046 18 20 18H4C2.8954 18 2 17.1046 2 16V14.8646C2.5679 15.2624 3.2556 15.5 4 15.5H20ZM20 19.5C20.7444 19.5 21.4321 19.2624 22 18.8646V20C22 21.1046 21.1046 22 20 22H4C2.8954 22 2 21.1046 2 20V18.8646C2.5679 19.2624 3.2556 19.5 4 19.5H20Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyCash);
export default __webpack_public_path__ + "static/media/money-cash.520d1240b12fe5676e506198c803d34e.svg";
export { ForwardRef as ReactComponent };